import { ReactNode } from "react";
import clsx from "clsx";

export const ButtonPage = ({
  disabled,
  page,
  icon,
  currentPage,
  onClick,
}: {
  disabled?: boolean;
  page?: number;
  icon?: ReactNode;
  currentPage: number;
  onClick: () => void;
}) => (
  <button
    type="button"
    disabled={disabled}
    className={clsx(
      "disabled:text-black-16",
      currentPage === page && "text-primary-100",
    )}
    onClick={onClick}
  >
    {icon || page}
  </button>
);
